import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferLabel: Record<OfferKindEnum, string> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% Off from {{minSpendValue}}',
  [OfferKindEnum.PercentageOffByProducts]: 'Save {{percentageAmount}}% on Selected Items',
  [OfferKindEnum.AmountOffByProducts]: 'Save {{amount}} on Selected Items',
  [OfferKindEnum.AmountOffByMinSpendValue]: 'Save {{amount}} from {{minSpendValue}}',
  [OfferKindEnum.Bogo]: '2 for the Price of 1 – Today Only',
  [OfferKindEnum.BogoHalfPrice]: 'Buy one get one half price',
  [OfferKindEnum.FreeItemByProducts]: 'Today: Secure Your Free Item!',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Today: Secure Your Free item with an order value!',
};

export default OfferLabel;
